import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { EmailTemplateType } from '@community-settings/core/enums/email-template-type.enum';

@Pipe({
    name: 'emailTemplatesTypesPipe',
})
export class EmailTemplatesTypesPipe implements PipeTransform {
    constructor(private translateService: TranslateService) {}

    transform(emailTemplatesTypes: EmailTemplateType) {
        switch (emailTemplatesTypes) {
            case EmailTemplateType.newTicketToAdmin:
                return this.translateService.instant('To teammates with access when a new ticket is posted');
            case EmailTemplateType.newTicketToCreator:
                return this.translateService.instant('Automatic reply to the customer when a new ticket is posted');
            case EmailTemplateType.newReplyToClient:
                return this.translateService.instant('To the customer when a teammate writes a reply');
            case EmailTemplateType.newReplyToStaff:
                return this.translateService.instant('To teammates with access when a customer replies back');
            case EmailTemplateType.assignedToVendor:
                return this.translateService.instant('To external users when access is given to a ticket');
            case EmailTemplateType.assignedToStaff:
                return this.translateService.instant('To teammates when access is given to a ticket');
            case EmailTemplateType.mentionedInNote:
                return this.translateService.instant('To teammates when they are mentioned in notes');
            case EmailTemplateType.newInternalTicketToCreator:
                return this.translateService.instant('To customers when a ticket is created manually');
            case EmailTemplateType.userAssignedToTicket:
                return this.translateService.instant(
                    'Sent to Teammate when a ticket is assigned to this user by another Teammate',
                );
            case EmailTemplateType.newReplyWithCustomerPortalLink:
                return this.translateService.instant('To the customer when a teammate writes a reply with portal link');
            case EmailTemplateType.newInternalTicketToCreatorWithCustomerPortalLink:
                return this.translateService.instant('To customers when a ticket is created manually with portal link');
            case EmailTemplateType.toCustomersWhenSendingASurvey:
                return this.translateService.instant('To customers when sending a survey');
            default:
                return this.translateService.instant('Unknown type');
        }
    }
}
